<template>
  <div class="radio-group">
    <label
      v-for="(option, index) in normalizedOptions"
      :key="index"
      class="radio-option"
    >
      <input
        type="radio"
        :value="option.value"
        v-model="modelValueLocal"
        class="radio-input"
      />
      <span class="radio-label">{{ option.label }}</span>
    </label>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [String, Number, Boolean],
    default: null,
  },
});

const emit = defineEmits(["update:modelValue"]);

const normalizedOptions = computed(() =>
  props.options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  )
);

const modelValueLocal = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});
</script>

<style scoped>
.radio-group {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border: 0.1rem solid #ddd;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
	line-height: 1;
	height: fit-content;
	font-weight: 100;
}

.radio-option:hover {
  border-color: #666;
}

.radio-input {
  display: none;
}

.radio-input:checked + .radio-label {
  font-weight: 600;
  color: var(--color-1);
}

.radio-input:checked + .radio-label {
	transition: 0.3s ease all;
}

.radio-label {
  transition: 0.2s ease;
}
</style>
